module.exports = __webpack_public_path__ + "img/Background_characters.61795468.jpeg";